export default {
  Title: 'Định dạng số',
  GeneralFormat: 'Định dạng chung',
  ReadAmount: 'Đọc số tiền',
  RestoreDefault: 'Lấy lại mặc định',
  SeperatorCharacter: 'Ký tự ngăn cách',
  CurrencyGroupSeparator: 'Hàng nghìn',
  Example: 'Ví dụ: ',
  CurrencyDecimalSeparator: 'Thập phân',
  NumberOfDecimalPlace: 'Số chữ số sau dấu phẩy',
  CurrencyDecimalDigits: 'Số tiền',
  NumberDecimalDigits: 'Số lượng',
  PercentDecimalDigits: 'Hệ số, tỷ lệ',
  CurrencySymbol: 'Ký hiệu tiền tệ',
  NumberNegativePattern: 'Ký hiệu',
  ShowNegativeNumber: 'Cách thể hiện số âm',
  CurrencyNegativeForeColor: 'Màu sắc',
  NegativeSymbol: 'Ký hiệu số âm',
  FirstPart: 'Phần đầu',
  LastPart: 'Phần cuối',
  SayMoney_IsCustomize: 'Tùy biến cách đọc số tiền',
  FirstCustomText: '(1) Hàng nghìn (nghìn, ngàn...)',
  SecondCustomText: '(2) Nối giữa hàng trăm và hàng đơn vị (linh, lẻ...)',
  ThirdCustomText: '(3) Nối giữa hàng chục và hàng đơn vị (mươi...)',
  FourCustomText: '(4) Số 4 của hàng đơn vị (bốn, tư,...)',
  FiveCustomText: '(5) Số 7 (bảy, bẩy...)',
  ReadTheAmount: 'Đọc thử số tiền',
  ReadEvenAmount: 'Đọc chẵn số tiền (123: Một trăm hai mươi ba đồng chẵn)',
  ReadingResult: 'Kết quả đọc: ',
  X: 'x',
  First: '(1)',
  Second: '(2)',
  Third: '(3)',
  XPattern: 'xxx xxx',
  Message: {
    Success: 'Cập nhật thành công',
    ErrorSuccess: 'Cập nhật không thành công',
  },
  Dong: 'đồng',
  Even: 'chẵn',
  Thousands: 'nghìn',
  ThousandsOfBillions: 'nghìn tỷ',
  Four: 'bốn',
};
